import type { ChakraProps } from '@chakra-ui/react';
import moment from 'moment';

// TODO: replace moment
import { Text } from '@frontend/components';
import { useDateFormat } from '@frontend/utils';

import { EmptyCellContent } from './EmptyCellContent';

export type DateCellContentProps = ChakraProps & {
  date?: string | null;
};

export const DateCellContent = ({
  date,
  ...props
}: DateCellContentProps): React.ReactElement => {
  const { dateFormat } = useDateFormat();
  if (date) {
    return (
      <Text textAlign="inherit" {...props}>
        {moment(date).local().format(dateFormat)}
      </Text>
    );
  } else {
    return <EmptyCellContent textAlign={'end'} />;
  }
};
